module.exports = __webpack_public_path__ + "static/media/landing1.f4637397.png";